module.exports = __webpack_public_path__ + "img/2x.efc10ab.jpg";